import { useLang } from "@/context/LanguageContext";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-10 pb-10 px-6">
      <p className="max-w-2xl mx-auto text-center text-[11px] leading-relaxed text-slate-400" data-testid="footer-text">
        {t("footer_text")}
      </p>
    </footer>
  );
}
